import "../../styles/bootstrap/bootstrap-popover.scss";
import "../../styles/popoverOverride.scss";

import PropTypes from "prop-types";
import React from "react";
import ImmutablePropTypes from "react-immutable-proptypes";
import { Popover, PopoverBody } from "reactstrap";

import CheckboxStates from "../../constants/checkboxStates";
import uniqueId from "../../utils/uniqueId";
import Icon from "../interface/Icon";
import AppSubmenuView from "./AppMenuView";

const iconForState = s => (s === CheckboxStates.CHECKED ? "tick" : s === CheckboxStates.MIXED ? "minus" : "blank");

class AppMenuItem extends React.Component {
  constructor(props) {
    super(props);

    this.showMenu = this.showMenu.bind(this);
    this.hasSubmenu = this.hasSubmenu.bind(this);
    this.onMouseDown = this.onMouseDown.bind(this);

    this._appMenuId = "x" + uniqueId();
  }

  hasSubmenu() {
    return this.props.children && this.props.children.size;
  }

  onMouseDown(e) {
    if (!this.props.disabled) {
      if (!this.hasSubmenu()) {
        this.props.onItemClick(this.props.messageType, this.props.value);
      } else if (!this.props.showSubMenu) {
        this.showMenu();
      }
    }
    e.preventDefault();
  }

  onToggleMenu() {
    this.props.onToggleMenu(this.props.itemIndex);
  }

  showMenu() {
    this.onToggleMenu();
  }

  renderMenu() {
    return (
      <AppSubmenuView
        menuItems={this.props.children}
        depth={this.props.depth + 1}
        canShowSubMenu={this.props.showSubMenu}
        onItemClick={this.props.onItemClick}
      />
    );
  }

  render() {
    const hasSubmenu = this.hasSubmenu();
    const classNames = [
      "appMenuItem",
      this.props.showSubMenu ? "menuOpen" : "",
      this.props.hasSeparator ? "hasBottomBorder" : "",
      this.props.disabled ? "disabled" : ""
    ];

    return (
      <div
        className={classNames.join(" ")}
        id={this._appMenuId}
        onMouseDown={this.onMouseDown}
        onMouseEnter={this.props.showOnHover ? this.showMenu : null}
      >
        {this.props.depth > 0 ? (
          <Icon icon={iconForState(this.props.state)} className="appMenuItemTick" color="iconMono" />
        ) : null}
        <div className="appMenuItemContent">
          <span className="appMenuItemLabel">{this.props.label}</span>
          {this.props.shortcut ? <span className="appMenuItemShortcut">{this.props.shortcut}</span> : null}
          {hasSubmenu && this.props.depth > 0 ? <Icon icon="rightArrow" /> : null}
        </div>
        {this.props.showSubMenu && hasSubmenu ? (
          <Popover
            className={`appMenuPopover`}
            placement={this.props.depth > 0 ? "right-start" : "bottom-start"}
            hideArrow={true}
            isOpen={this.props.showSubMenu}
            target={this._appMenuId}
            onMouseEnter={this.showMenu}
            trigger="legacy"
          >
            <PopoverBody onClick={e => e.stopPropagation()}>{this.renderMenu()}</PopoverBody>
          </Popover>
        ) : null}
      </div>
    );
  }
}

AppMenuItem.propTypes = {
  depth: PropTypes.number.isRequired,
  label: PropTypes.string,
  messageType: PropTypes.string,
  value: PropTypes.string,
  shortcut: PropTypes.string,
  disabled: PropTypes.bool,
  state: PropTypes.string,
  children: ImmutablePropTypes.list,
  onItemClick: PropTypes.func,
  onToggleMenu: PropTypes.func.isRequired,
  showOnHover: PropTypes.bool.isRequired,
  showSubMenu: PropTypes.bool.isRequired,
  itemIndex: PropTypes.number.isRequired,
  hasSeparator: PropTypes.bool.isRequired
};

export default AppMenuItem;
